module.exports = __webpack_public_path__ + "img/slide1.f258ff98.png";